import gettext from '@sdk/lang/gettext';
import { useSession } from '@sdk/session/SessionContext';

import { ArticleComment } from '@web/newsfeed/types/Article';
import TextEditorModal from '@web/richText/TextEditorModal/TextEditorModal';
import { useEditCommentModal } from '@web/newsfeed/Article/ArticleComments/EditCommentModal/editCommentModal.hooks';

type Props = {
  comment: ArticleComment | null;
  onClose: () => void;
};

export const EditCommentModal = ({ comment, onClose }: Props) => {
  const { currentUser } = useSession();
  const { onSubmit, mentionPersonas } = useEditCommentModal(comment, onClose);

  if (!comment) {
    return null;
  }

  return (
    <TextEditorModal
      initialValue={comment.content}
      initialAttachments={comment.attachments}
      currentUser={currentUser}
      personas={mentionPersonas}
      isOpen={!!comment}
      onClose={onClose}
      onSubmit={onSubmit}
      titleText={gettext('Edit comment')}
      hiddenToolbarControls
    />
  );
};
